<template>
    <div>
        <div class="col-lg-12">
            <b-tabs justified active-nav-item-class="font-weight-bold" nav-class="nav-tabs-custom cus-document" content-class="p-3 text-muted">
                <b-tab v-for="(tab, index) in tabDesign" :key="index" class="border-0">
                    <template v-slot:title>
                        <span class="">{{ tab.name }}</span>
                    </template>
                    <div>
                        <div v-if="tab.id == 1">
                            <TemplateDesign ref="templateDesign" :templateForm.sync="designForm.setting_designs" />
                        </div>
                        <div v-if="tab.id == 2">
                            <form class="needs-validation" autocomplete="off">
                                <div class="form-group row">
                                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingDesign.header') }} </label>
                                    <div class="col-sm-9">
                                        <Editor
                                            :id="`designForm_header`"
                                            :model.sync="designForm.header"
                                            :modelEvents="`change keydown blur focus paste`"
                                            :configInit="configEditor"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingDesign.footer') }} </label>
                                    <div class="col-sm-9">
                                        <Editor
                                            :id="`dataForm_footer`"
                                            :model.sync="designForm.footer"
                                            :modelEvents="`change keydown blur focus paste`"
                                            :configInit="configEditor"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingDesign.GA') }} </label>
                                    <div class="col-sm-9">
                                        <textarea rows="3" v-model="designForm.google_analytics" class="form-control"></textarea>
                                        <span style="font-size: 12px">{{ $t('managerForm.settingDesign.noteGA') }}</span>
                                    </div>
                                </div>
                                <!-- <div class="form-group row">
                                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingDesign.title') }} </label>
                                    <div class="col-sm-9">
                                        <textarea rows="3" v-model="designForm.meta_title" class="form-control"></textarea>
                                    </div>
                                </div> -->
                                <div class="form-group row">
                                    <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                                        >{{ $t('managerForm.settingDesign.description') }}
                                    </label>
                                    <div class="col-sm-9">
                                        <textarea rows="3" v-model="designForm.description" class="form-control"></textarea>
                                        <span style="font-size: 12px">{{ $t('managerForm.settingDesign.noteDescription') }}</span>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
import { validateField } from '@/utils/validate';
import { cloneDeep } from 'lodash';

import TemplateDesign from './template.vue';
import Editor from '@/components/Editor/main.vue';

export default {
    name: 'SettingDesign',
    components: {
        TemplateDesign,
        Editor
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            tabDesign: [
                { id: 1, name: '共通デザイン' },
                { id: 2, name: 'ヘッダー・フッター' }
            ],
            designForm: cloneDeep(this.dataForm),
            configEditor: {
                height: 600,
                content_style:
                    "@import url('https://fonts.googleapis.com/css2?family=Hachi+Maru+Pop&family=M+PLUS+1p&family=Noto+Sans+JP:wght@100..900&family=Noto+Serif+JP:wght@200..900&family=Sawarabi+Gothic&family=Yuji+Mai&family=Zen+Old+Mincho&display=swap');",
                font_formats: 'Noto Sans JP;Hachi Maru Pop;Yuji Mai;Noto Serif JP;M PLUS 1p;Sawarabi Gothic;Zen Old Mincho'
            }
        };
    },
    methods: {
        handleValidateField(configField) {
            validateField(configField);
        },
        refreshCodeMirror() {
            this.$refs.templateDesign[0].refreshCodeMirror();
        }
    },
    watch: {
        dataForm: {
            handler(newDataForm) {
                this.designForm = newDataForm;
            },
            immediate: true,
            deep: true
        },

        designForm: {
            handler(newVal) {
                this.$emit('update:dataForm', newVal);
            },
            deep: true
        }
    }
};
</script>

<style lang="scss"></style>
